import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class PedidosProdutosPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaProduto, buscaGrupoProduto, buscaMarcaProduto, buscaUsuario } = this.props.filtros;

        let dataIni = '';
        if ((buscaDataIni) && (buscaDataIni !== undefined)) {
            dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        let dataFim = '';
        if ((buscaDataFim) && (buscaDataFim !== undefined)) {
            dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        axios
            .get('/vendas/listaProdutosHistorico', {
                params: {
                    print: true,
                    numero: buscaControle,
                    pessoa: buscaPessoa.key,
                    produto: buscaProduto.pest_item,
                    tamanho: buscaProduto.pest_tamanho,
                    cor: buscaProduto.pest_cor,
                    grupoProduto: buscaGrupoProduto.key,
                    marcaProduto: buscaMarcaProduto.key,
                    usuario: buscaUsuario.key,
                    dataIni,
                    dataFim,
                }
            })
            .then(response => {
                const { data } = response;
                this.setState({
                    listaRegistros: data.dados,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr, registro) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderData = (data, registro) => {
        const dataMoment = registro.ven_dt_venda ? moment(registro.ven_dt_venda) : moment(registro.os_data_emissao);
        if (dataMoment) {
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            return (
                <span></span>
            )
        }
    }

    renderNumero = (data, registro) => {
        return (
            <span>
                {registro.ven_numero ? registro.ven_numero : registro.os_numero}
            </span>
        )
    }

    renderNome = (data, registro) => {
        return (
            <span>
                {registro.nome_venda ? registro.nome_venda : registro.nome_os}
            </span>
        )
    }

    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Relatório de Produtos Vendidos
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Qtde: </span>
                                <span>{this.renderValor(this.props.qtdeVendas)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Total: </span>
                                <span>R$ {this.renderValor(this.props.totalVendas)}</span>
                            </Col>
                        </Row>

                        <Table
                            pagination={false}
                            dataSource={listaRegistros}
                            className="tabela"
                            rowKey={(listaRegistros => listaRegistros.mi_idf)}
                            loading={{
                                spinning: carregando,
                                tip: 'Carregando. Aguarde...',
                                size: "large"
                            }}
                        >
                            <Column
                                key="ven_dt_venda"
                                dataIndex="ven_dt_venda"
                                title="Emissão"
                                render={this.renderData}
                                width={160}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="ven_numero"
                                dataIndex="ven_numero"
                                title="Num"
                                render={this.renderNumero}
                                width={80}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="pes_nome"
                                dataIndex="pes_nome"
                                title="Cliente"
                                render={this.renderNome}
                                width={200}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="prod_codigo"
                                dataIndex="prod_codigo"
                                title="Prod"
                                width={80}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="prod_descricao"
                                dataIndex="prod_descricao"
                                title="Descrição Produto"
                                width={200}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="grp_descricao"
                                dataIndex="grp_descricao"
                                title="Grp Produto"
                                width={150}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="mi_qtde"
                                dataIndex="mi_qtde"
                                title="Qtde"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="mi_vlr_unit"
                                dataIndex="mi_vlr_unit"
                                title="Vlr Unit"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="mi_vlr_total"
                                dataIndex="mi_vlr_total"
                                title="Vlr Total"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                        </Table>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default PedidosProdutosPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/PedidosProdutosPrintModal.js